import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitQuote = (payload) => api.post("/quotes", payload).then((r) => r.data);

export const externalCheckout = (cart) => {
  if (!window.externalCheckout || typeof window.externalCheckout.go !== "function") {
    throw new Error("external checkout not loaded");
  }
  return window.externalCheckout.go(cart.map((i) => ({ vitrine_id: i.id, qty: i.quantity })));
};

export const getCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);
